import api from '../config/api';

export const login = async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
};

export const register = async (username, email, password) => {
    const response = await api.post('/auth/register', { username, email, password });
    return response.data;
};

export const logout = async () => {
    try {
        await api.post('/auth/logout');
    } catch {}
};

export const checkAuth = async () => {
    try {
        const response = await api.get('/auth/check');
        return response.data;
    } catch {
        return { success: false };
    }
};

export const refreshToken = async () => {
    const token = localStorage.getItem('refresh_token');
    const response = await api.post('/auth/refresh', {}, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    localStorage.setItem('access_token', response.data.access_token);
    return response.data;
};

export const getProfile = async () => {
    const response = await api.get('/auth/profile');
    return response.data;
};

export const vkAuth = async (code, device_id, access_token) => {
    const response = await api.post('/auth/vk/verify', { code, device_id, access_token });
    return response.data;
};

export const yandexAuth = async (code) => {
    const response = await api.post('/auth/yandex/verify', { code });
    return response.data;
};
